export default function combineAddressLists(teamAddrs, userAddrs, defaultTeamAddrId, userTag='user') {
  // Combine address lists. This decorates the addresses, so that UI can treat the types the same.
  teamAddrs = tagAddrs('team', teamAddrs);
  userAddrs = tagAddrs(userTag, userAddrs);
  if (defaultTeamAddrId) {
    // Set is_default_for_shipping flag on the team address.
    // This way UI can just use this flag.
    teamAddrs.forEach(addr => {
      if (addr.id === defaultTeamAddrId) {
        addr.is_default_for_shipping = true;
      }
    });
    // Unset flag on the user addrs. At API level, the is_default_for_shipping flag is not written
    // to user addresses when a team address is favorited, so for the UI to be able to use the flag
    // we clear it now.
    userAddrs.forEach(addr => addr.is_default_for_shipping = false);
  }
  return userAddrs.concat(teamAddrs);
}

function tagAddrs(type, addrs) {
  return (addrs || []).map(a => ({...a, type}));
}



// WEBPACK FOOTER //
// ./src/lib/combineAddressLists.js